import type { YuzuPaperSize, YuzuTemplatePage } from '@giftie/yuzu-integration'
import type { GreetingCardFormat } from '@giftie/shared/greeting-cards'
import {
  GREETING_CARD_FRONT_PAGE_INDEX,
  getGreetingCardInsidePageIndex,
} from '@giftie/shared/greeting-cards'

/** Sorts Yuzu pages without changing their stored page indexes. */
export function sortYuzuPages(pages: YuzuTemplatePage[]): YuzuTemplatePage[] {
  return [...pages].sort((first, second) => first.page_index - second.page_index)
}

/** Finds the front page by its stored index rather than its array position. */
export function findYuzuFrontPage(pages: YuzuTemplatePage[]) {
  return pages.find(
    (page) => page.page_index === GREETING_CARD_FRONT_PAGE_INDEX,
  ) ?? null
}

/**
 * Finds the inside-message page by its stored index. Folded cards keep the
 * message on the inside face that the fold edge makes critical, so the index
 * depends on orientation as well as card format.
 */
export function findYuzuInsidePage(
  pages: YuzuTemplatePage[],
  cardFormat: GreetingCardFormat,
) {
  const orientation = findYuzuFrontPage(pages)?.orientation
    ?? pages[0]?.orientation
    ?? 'portrait'
  const insidePageIndex = getGreetingCardInsidePageIndex(
    cardFormat,
    orientation,
  )

  return pages.find((page) => page.page_index === insidePageIndex) ?? null
}

/** Returns the physical page dimensions after applying its orientation. */
export function getYuzuPageDimensions(
  paperSize: YuzuPaperSize,
  orientation: YuzuTemplatePage['orientation'],
) {
  return orientation === 'landscape'
    ? { width: paperSize.height, height: paperSize.width }
    : { width: paperSize.width, height: paperSize.height }
}
